import Rice from '../media/Rice.jpg'
import construction from '../media/construction.webp'
import copper from '../media/copper.webp'
import sugar from '../media/sugar.webp'
import container from '../media/container.webp'
import cars from '../media/cars.webp'


export const Offerings = [
    {
        imgSrc: Rice,
        cardTitle: 'Basmati Rice',
        cardText: 'Sella and other varieties of Basmati rice, known for their unmatched aroma and quality, exported to major markets across the globe.'
    },
    {
        imgSrc: sugar,
        cardTitle: 'ICUMSA 45 White Sugar',
        cardText: 'Imported from Brazil, this high-purity sugar meets the most rigorous standards for food quality, ensuring a top-tier product for our customers.'
    },
    {
        imgSrc: cars,
        cardTitle: 'Japanese Cars',
        cardText: 'Enjoy the reliability and advanced technology of our Japanese cars, designed for performance and comfort. '
    },
    {
        imgSrc: container,
        cardTitle: 'Container Solutions',
        cardText: 'Our containers, ranging from 20ft to 40ft, ensure safe transportation and storage of goods, supporting your import/export needs.'
    },
    {
        imgSrc: copper,
        cardTitle: 'Copper',
        cardText: 'With our 99.99% pure copper ingots, we ensure you receive only the best for your industrial applications.'
    },
    {
        imgSrc: construction,
        cardTitle: 'Construction',
        cardText: 'We supply essential materials for construction projects, ensuring the highest standards and reliability.'
    },
]

export const testimonials = [
    {
        review: "Working with Al-Mutawakkal Traders has been a great experience. They’re always reliable and supportive, and their dedication to quality really stands out. We’ve teamed up on many projects, and their partnership has been a big help.",
        clientName: 'Qureshi Venture',
        clientDes: 'CEO',
    },
    {
        review: "Al-Mutawakkal Traders is committed to quality, and it shows in every product they bring to us for testing. They prioritize rigorous standards, ensuring that their products are consistently certified to meet market expectations. It’s a pleasure to work with a company that values quality as much as we do.",
        clientName: 'SGS',
        clientDes: 'Quality Assurance Manager',
    },
    {
        review: "We have worked with Al-Mutawakkal Traders numerous times and they’re always there to support us. They’re easy to work with and always deliver on their promises. We value their commitment and the strong relationship we’ve built together.",
        clientName: 'Abaseen',
        clientDes: 'Managing Director',
    },
]